// A panel body with nothing in it: an optional icon, one sentence, and an
// optional action passed through the default slot.
const EmptyState = {
  props: {
    message: { type: String, required: true },
    icon: { type: String, default: null },
  },
}

export default EmptyState
